import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "antd/dist/reset.css";
import { Provider } from "react-redux";
import store from "./store";
import AppRoutes from "./routes";
import { message } from "antd";

// Detect iOS/Android WebView
const isWebView = () => {
  const ua = navigator.userAgent || "";

  const isIOS = /iPhone|iPad|iPod/.test(ua);

  // iOS WebView detection: No "Safari" AND has "Mobile/"
  const isIOSWebView = isIOS && !/Safari/.test(ua) && /Mobile/.test(ua);

  // Android WebView detection: Presence of "; wv" or "Version/"
  const isAndroidWebView =
    /; wv\)/.test(ua) || /Version\/[\d.]+ Chrome\/[\d.]+/.test(ua);

  return isIOSWebView || isAndroidWebView;
};

if (isWebView()) {
  document.body.classList.add("mobile-app");
}

const setFavicon = () => {
  const favicon =
    document.querySelector("link[rel='icon']") ||
    document.createElement("link");
  favicon.rel = "icon";
  let path = window.location.hostname;
  if (
    path === "pharmaerp.forthapps.com" ||
    path === "pharmaerp-dev.forthapps.com" ||
    path === "pharmaacc.forthapps.com" ||
    path === "pharmaacc-dev.forthapps.com"
  ) {
    favicon.href = "/favicon-pharma.svg";
  } else {
    favicon.href = "/favicon-erp.svg";
  }

  document.head.appendChild(favicon);
};

setFavicon();

message.config({
  top: 80,
  duration: 2.5,
  maxCount: 3,
});

const isLoginPage = window.location.pathname === "/login";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    {/* { !isLoginPage && !isWebView() &&  (
      <div
        style={{
          height: "env(safe-area-inset-top)",
          background: "linear-gradient(90deg, #001529, #003A8C)",
        }}
      />
    )} */}
    <AppRoutes />
  </Provider>
);
